import { useClassFactory, useNetworkService } from "@pasta/box-v2";
import { type AppContextDto } from "../dto/app-context.dto";

export class AppContextApi {
  get network() {
    return useNetworkService();
  }

  async fetchContext(): Promise<AppContextDto> {
    return (await this.network.get("/app-context")).data;
  }
}

export const [appContextClientToken, useAppContextApi] = useClassFactory(AppContextApi);
